module.exports = __webpack_public_path__ + "assets/img/isv_1.b458e4fc.png";